import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import {
    STUDENT_INFO_BUS_ROUTE,
    STUDENT_INFO_CURRENT_ENROLLMENT,
    STUDENT_INFO_CUSTOM_ATTRIBUTES,
    STUDENT_INFO_CUSTOM_ATTRIBUTE_CREATE,
    STUDENT_INFO_GET,
    STUDENT_INFO_GUARDIAN_HOUSEHOLD,
    STUDENT_INFO_INDIVIDUAL_PERSON_READ,
    STUDENT_INFO_SAE_OPT_OUTS,
    STUDENT_INFO_STUDENT,
    STUDENTS_BY_GUARDIAN_GET
} from "../const/StudentInfoConst";

/**
 * Data Access for the User API
 * @name StudentInfoDao
 * @param {{}} props
 * @return {null|*}
 */
const StudentInfoDao = (props) => {
    const {
        action,
        attributeName,
        dto,
        objectName,
        params,
        personId,
        schoolId,
        schoolYearKey,
        studentNumber,
        token,
        username
    } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };
    switch (action) {
        case "currentEnrollmentRead":
            options.method = "GET";
            options.url = `${STUDENT_INFO_CURRENT_ENROLLMENT}/${studentNumber}/detail.json`;
            break;
        case "customAttributeCreate":
            options.data = dto;
            options.method = "POST";
            options.url = `${STUDENT_INFO_CUSTOM_ATTRIBUTE_CREATE}/${studentNumber}/detail.json`;
            break;
        case "customAttributeRead":
            options.method = "GET";
            options.params = params;
            options.url = `${STUDENT_INFO_CUSTOM_ATTRIBUTES}/${studentNumber}/${attributeName}/${objectName}/detail.json`;
            break;
        case "customAttributesRead":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.url = `${STUDENT_INFO_CUSTOM_ATTRIBUTES}/${studentNumber}/index.json`;
            break;
        case "saeOptOutsRead":
            options.method = "GET";
            options.url = `${STUDENT_INFO_SAE_OPT_OUTS}/${studentNumber}/${schoolYearKey}/index.json`;
            break;
        case "studentsByGuardianRead":
            options.method = "GET";
            options.params = params;
            options.url = `${STUDENTS_BY_GUARDIAN_GET}/${username}/index.json`;
            break;
        case "guardianHouseholdFromUsernameRead":
            options.method = "GET";
            options.url = `${STUDENT_INFO_GUARDIAN_HOUSEHOLD}/${username}/detail.json`;
            break;
        case "studentBusRoutesRead":
            options.method = "GET";
            options.url = `${STUDENT_INFO_BUS_ROUTE}/${studentNumber}/detail.json`;
            break;
        case "studentImageRead":
            options.method = "GET";
            options.responseType = "blob";
            options.url = `${STUDENT_INFO_STUDENT}/${studentNumber}/${schoolYearKey}/image`;
            break;
        case "studentInfoRead":
            options.method = "GET";
            options.url = `${STUDENT_INFO_GET}/${studentNumber}/summary.json`;
            break;
        case "studentInfoIndividualPersonRead":
            options.method = "GET";
            options.url = `${STUDENT_INFO_INDIVIDUAL_PERSON_READ}/${personId}/detail.json`;
            break;
        case "studentInfoStudentRead":
            options.method = "GET";
            options.url = `${STUDENT_INFO_STUDENT}/${personId}/${schoolId}/detail.json`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

StudentInfoDao.propTypes = {
    action: PropTypes.string.isRequired,
    attributeName: PropTypes.string,
    dto: PropTypes.oneOfType([PropTypes.object]),
    objectName: PropTypes.string,
    params: PropTypes.oneOfType([PropTypes.object]),
    personId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    schoolId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    schoolYearKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    studentNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    token: PropTypes.string.isRequired,
    username: PropTypes.string
};

StudentInfoDao.defaultProps = {
    attributeName: null,
    dto: null,
    objectName: null,
    params: null,
    personId: null,
    schoolId: null,
    schoolYearKey: null,
    studentNumber: null,
    username: null
};

export default StudentInfoDao;
